import { database } from '../firebase/firebase';
import { ref, push } from 'firebase/database';

export const notificationService = {
  // Create a notification
  createNotification: async (notificationData) => {
    try {
      const notificationsRef = ref(database, 'notifications');
      await push(notificationsRef, {
        ...notificationData,
        notification_created_at: new Date().toISOString()
      });
    } catch (error) {
      console.error("Error creating notification:", error);
      throw error;
    }
  },

  // Create product approval notification
  createProductApprovalNotification: async (product, userId) => {
    const currentDate = new Date().toISOString();
    const expirationDate = new Date(currentDate);
    expirationDate.setDate(expirationDate.getDate() + 30);

    return notificationService.createNotification({
      notification_user_id: userId,
      notification_title: "Product approved",
      notification_message: `Your product "${product.product_name}" has been approved.`,
      notification_type: "success",
      notification_is_read: false,
      notification_action_url: '/Edit_Products',
      notification_priority: "Low",
      notification_expires_at: expirationDate.toISOString()
    });
  },

  // Create product rejection notification
  createProductRejectionNotification: async (product, userId, rejectionReason) => {
    const currentDate = new Date().toISOString();
    const expirationDate = new Date(currentDate);
    expirationDate.setDate(expirationDate.getDate() + 30);

    return notificationService.createNotification({
      notification_user_id: userId,
      notification_title: "Product Rejected",
      notification_message: `Your product "${product.product_name}" was rejected: ${rejectionReason}`,
      notification_type: "error",
      notification_is_read: false,
      notification_action_url: '/Edit_Products',
      notification_priority: "Low",
      notification_expires_at: expirationDate.toISOString()
    });
  }, 


  // Create product update request notification
  createProductUpdateRequestNotification: async (product, userId, updateMessage) => {
    const currentDate = new Date().toISOString();
    const expirationDate = new Date(currentDate);
    expirationDate.setDate(expirationDate.getDate() + 30);
  
    return notificationService.createNotification({
      notification_user_id: userId,
      notification_title: "Update Required",
      notification_message: `Your product "${product.product_name}" requires additional information: ${updateMessage}`,
      notification_type: "warning",
      notification_is_read: false,
      notification_action_url: '/Product_Request_Interface',
      notification_priority: "Medium",
      notification_expires_at: expirationDate.toISOString()
    });
  },

    // Create shift assignment notification
    createShiftAssignmentNotification: async (shiftDetails, userId) => {
      const currentDate = new Date().toISOString();
      const expirationDate = new Date(currentDate);
      expirationDate.setDate(expirationDate.getDate() + 7);
  
      return notificationService.createNotification({
        notification_user_id: userId,
        notification_title: "New Shift Assigned",
        notification_message: `You have been assigned to a new shift on ${new Date(shiftDetails.shift_scheduled_start).toLocaleDateString()} from ${new Date(shiftDetails.shift_scheduled_start).toLocaleTimeString()} to ${new Date(shiftDetails.shift_scheduled_end).toLocaleTimeString()}`,
        notification_type: "info",
        notification_is_read: false,
        notification_action_url: '/my-shifts',
        notification_priority: "Medium",
        notification_expires_at: expirationDate.toISOString()
      });
    },
  
    // Create backup request notification
    createBackupRequestNotification: async (backupDetails, userId) => {
      const currentDate = new Date().toISOString();
      const expirationDate = new Date(currentDate);
      expirationDate.setDate(expirationDate.getDate() + 2);
  
      return notificationService.createNotification({
        notification_user_id: userId,
        notification_title: "Backup Shift Request",
        notification_message: `You have been assigned as backup for a shift: ${backupDetails.reason}`,
        notification_type: "warning",
        notification_is_read: false,
        notification_action_url: '/my-shifts',
        notification_priority: "High",
        notification_expires_at: expirationDate.toISOString()
      });
    },
};